export interface Form {
    // 标题
    label: string
    // 重置、验证的属性名
    prop: string
    // 初始值
    value?: any
    // 何种类型的表单
    formType: FormType
    // 当formType是 SELECT 需要配置selectKey 和  selectValue
    selectKey?: string
    selectValue?: string
    // 下拉框
    selects?: Array<any>
    // 下拉框的可选项
    selectOption?: SelectOption
    // 验证规则
    rule?: Array<any>[] | object
    // 当formType是 AUTOCOMPLETE 需要配置该函数 结果通过callback函数回传给控件
    querySuggestions?: (word: string, callback: Function) => any
    // 异步查询select数据 callback返回数据
    querySelects?: (formItem: Form, callback: Function) => any
    // 异步查询级联数据 callback返回数据
    queryCascadeOptions?: (formItem: Form, callback: Function) => any
    desc?: string
    inputType?: InputType // 输入类型
    maxlength?: number // 最大长度
    // 当formType是 DATE_TIMERANGE 需要重写这个属性 告诉表单开始的key和结束的key分别是什么 并且是否需要转为时间戳
    dateTimeRange?: DateTimeRange
    // 是否禁用当前表单
    disabled?: boolean

    // 级联类型需要配置下面的选项
    options?: any
    props?: Prop

    // 换行
    isNewLine?: boolean
}

/**
 * 级联相关配置项
 */
export interface Prop {
    label: string
    value: string
    children: string
}

/**
 * 下拉框可选配置
 */
export interface SelectOption {
    labelKey: string
    valueKey: string
    filterable?: boolean
    multiple?: boolean
    collapseTags?: boolean
}

export interface DateTimeRange {
    // 是否需要转成时间戳
    isTimestamp?: boolean
    startTimeKey: string
    endTimeKey: string
}

export enum InputType {
    TEXT,
    MONEY,
    NUM,
    IDCARD,
    MOBILE
}

function createFilter(queryString: string) {
    return (restaurant: any) => {
        return restaurant.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0
    }
}

/**
 * 过滤匹配的文字
 * @param queryString
 * @param arrays
 */
export function filter(queryString: string, arrays: any[]): any[] {
    return queryString ? arrays.filter(createFilter(queryString)) : arrays
}

/**
 *查询所有的参数
 */
export interface QueryParam {
    pageNum?: number
    pageSize?: number
}

/**
 * 表单类型
 */
export enum FormType {
    // 输入框类型
    INPUT,
    // 下拉框类型
    SELECT,
    // 自动匹配类型
    AUTOCOMPLETE,
    // 级联类型
    CASCADER,
    // 普通日期类型
    DATE_TIME,
    // 带范围的日期类型
    DATE_TIMERANGE
}

export enum ColumnType {
    TEXT,
    DATE,
    ENUM,
    CUSTOM
}

/**
 * 用来处理用户列表中的自定义操作事件
 */
export interface Event {
    label: string
    // 配置多个事件用来区分
    eventCode: any | number
    desc?: string
    // 是否取当前列本身的数据
    labelIsProp?: boolean
    canCopy?: boolean
}

/**
 * 当操作列被点击将数据回传给上层页面，并且将配置的code传递上去，以便区分究竟是哪种操作
 */
export interface EventDetail extends Event {
    data: any
    column?: Column
}

export interface Column {
    prop: string
    width?: string
    select?: boolean
    fixed?: string
    columnName: string
    custom?: boolean
    desc?: string
    // 是否需要合并表头
    children?: Array<Column>
    columnType?: ColumnType
    // 返回对应列的枚举值
    getEnum?: (value: any) => string
    // 自定义事件 当前列可以配置多个事件，包含名称 、code
    events?: Event[]
    // 根据数据自定义展示信息
    getCustomInfo?: (row: any, prop: string) => string
}
